//Styles
import Styles from "./ScreenSaver.module.scss"
const ScreenSaver = () => {
  return (
    <div  className={Styles.container} id="screenSaver"></div>
  )
}

export default ScreenSaver
